import { createPinia } from 'pinia';
import type { App } from 'vue';
import { registeGlobalParam } from '@mts/utils';
import { registerPiniaPersistPlugin } from '@/store/plugin/persist';
import { useAppStore } from './modules/app';
import { useErrorLogStore } from './modules/errorLog';
import { useGlobalStore } from './modules/global';
import { useLocaleStore } from './modules/locale';
import { useMultipleTabStore } from './modules/multipleTab';
import { usePermissionStore } from './modules/permission';
import { useTableSettingStore } from './modules/tableSetting';
import { useUserStore } from './modules/user';

const store = createPinia();
registerPiniaPersistPlugin(store);

registeGlobalParam({ store });

export function setupStore(app: App<Element>) {
  app.use(store);
}

export { store };

let appStoreInstance: ReturnType<typeof useAppStore>;
export function getAppStore() {
  if (!appStoreInstance) {
    appStoreInstance = useAppStore(store);
  }
  return appStoreInstance;
}

let userStoreInstance: ReturnType<typeof useUserStore>;
export function getUserStore() {
  if (!userStoreInstance) {
    userStoreInstance = useUserStore(store);
  }
  return userStoreInstance;
}

let globalStoreInstance: ReturnType<typeof useGlobalStore>;
export function getGlobalStore() {
  if (!globalStoreInstance) {
    globalStoreInstance = useGlobalStore(store);
  }
  return globalStoreInstance;
}

let permissionStoreInstance: ReturnType<typeof usePermissionStore>;
export function getPermissionStore() {
  if (!permissionStoreInstance) {
    permissionStoreInstance = usePermissionStore(store);
  }
  return permissionStoreInstance;
}

let localeStoreInstance: ReturnType<typeof useLocaleStore>;
export function getLocaleStore() {
  if (!localeStoreInstance) {
    localeStoreInstance = useLocaleStore(store);
  }
  return localeStoreInstance;
}

let tableSettingStoreInstance: ReturnType<typeof useTableSettingStore>;
export function getTableSettingStore() {
  if (!tableSettingStoreInstance) {
    tableSettingStoreInstance = useTableSettingStore(store);
  }
  return tableSettingStoreInstance;
}

let multipleTabStoreInstance: ReturnType<typeof useMultipleTabStore>;
export function getMultipleTabStore() {
  if (!multipleTabStoreInstance) {
    multipleTabStoreInstance = useMultipleTabStore(store);
  }
  return multipleTabStoreInstance;
}

let errorLogStoreInstance: ReturnType<typeof useErrorLogStore>;
export function getErrorLogStore() {
  if (!errorLogStoreInstance) {
    errorLogStoreInstance = useErrorLogStore(store);
  }
  return errorLogStoreInstance;
}
